import { useEffect, useState } from "react";
import api from "../api";
import { Link } from "react-router-dom";
import MessageSendForm from "../components/MessageSendForm";

export default function MessagesInbox() {
  const [showForm, setShowForm] = useState(false);
  const [messages, setMessages] = useState([]);
  const [sentMessages, setSentMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [tab, setTab] = useState("inbox");

  useEffect(() => {
    setLoading(true);
    api.get("/messages/inbox")
      .then(res => {
        console.log("[DEBUG] Inbox API response:", res.data);
        setMessages(res.data);
      })
      .catch(e => setError(e?.response?.data?.error || "Fehler beim Laden der Nachrichten"))
      .finally(() => setLoading(false));
    // Fetch sent messages
    api.get("/messages/sent")
      .then(res => {
        console.log("[DEBUG] Sent API response:", res.data);
        setSentMessages(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <div style={{ width: '100vw', margin: 0, padding: 0 }}>
      <div style={{ maxWidth: 700, margin: "40px auto", padding: 24, background: "#222", borderRadius: 12, color: "#fff", position: 'relative' }}>
        <h2 style={{ textAlign: "center", marginBottom: 24 }}>Nachrichten</h2>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginBottom: 24 }}>
          <button onClick={() => setTab('inbox')} style={{ padding: '8px 18px', borderRadius: 8, fontWeight: 600, border: tab === 'inbox' ? '2px solid #32CD89' : 'none', background: tab === 'inbox' ? '#32CD89' : '#333', color: '#fff', cursor: 'pointer' }}>Empfangen</button>
          <button onClick={() => setTab('sent')} style={{ padding: '8px 18px', borderRadius: 8, fontWeight: 600, border: tab === 'sent' ? '2px solid #32CD89' : 'none', background: tab === 'sent' ? '#32CD89' : '#333', color: '#fff', cursor: 'pointer' }}>Gesendet</button>
        </div>
        <button
          style={{ position: 'absolute', right: 24, top: 24, background: '#32CD89', color: '#fff', padding: '8px 18px', borderRadius: 8, fontWeight: 600, border: 'none', boxShadow: '0 2px 8px #32CD8940', cursor: 'pointer' }}
          onClick={() => setShowForm(true)}
        >
          Neue Nachricht
        </button>
        {showForm && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: '#000a', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ position: 'relative' }}>
              <MessageSendForm onSent={(result) => {
                if (result && result.success) {
                  setTimeout(() => setShowForm(false), 1200);
                }
              }} />
              <button
                style={{ position: 'absolute', top: 8, right: 8, background: '#c00', color: '#fff', border: 'none', borderRadius: 8, padding: '4px 12px', fontWeight: 600, cursor: 'pointer' }}
                onClick={() => setShowForm(false)}
              >
                Schließen
              </button>
            </div>
          </div>
        )}
        {loading && <div>Nachrichten werden geladen...</div>}
        {error && <div style={{ color: "#c00", marginBottom: 16 }}>{error}</div>}
        {tab === 'inbox' ? (
          messages.length === 0 && !loading ? (
            <div style={{ color: "#888", textAlign: "center", marginTop: 24 }}>Keine Nachrichten vorhanden.</div>
          ) : (
            <ul style={{ listStyle: "none", padding: 0 }}>
              {messages.map(msg => (
                <li key={msg.id} style={{ marginBottom: 18, background: msg.read ? "#333" : "#2e7d32", borderRadius: 8, padding: "12px 18px", color: msg.read ? "#fff" : "#fff" }}>
                  <div style={{ fontWeight: 600, fontSize: "1.1em" }}>
                    {msg.subject || <span style={{ opacity: 0.7 }}>(Kein Betreff)</span>}
                  </div>
                  <div style={{ opacity: 0.8, marginBottom: 6 }}>
                    {msg.type === "private" && <>Von: <b>{msg.senderDisplayName || msg.senderUsername || msg.senderId}</b> &bull; An: <b>{msg.recipientDisplayName || msg.recipientUsername || msg.recipientId}</b></>}
                    {msg.type === "broadcast" && <>Rundmail von Admin</>}
                    {msg.type === "system" && <>Systemnachricht</>}
                    &nbsp;•&nbsp; {new Date(msg.sentAt).toLocaleString()}
                  </div>
                  <div style={{ marginBottom: 8 }}>{msg.body}</div>
                  <Link to={`/messages/${msg.id}`} style={{ background: "#32CD89", color: "#fff", padding: "8px 16px", borderRadius: 8, fontWeight: 500, textDecoration: "none" }}>Details</Link>
                </li>
              ))}
            </ul>
          )
        ) : (
          sentMessages.length === 0 ? (
            <div style={{ color: "#888", textAlign: "center", marginTop: 24 }}>Keine gesendeten Nachrichten.</div>
          ) : (
            <ul style={{ listStyle: "none", padding: 0 }}>
              {sentMessages.map(msg => (
                <li key={msg.id} style={{ marginBottom: 18, background: "#333", borderRadius: 8, padding: "12px 18px", color: "#fff", position: 'relative' }}>
                  <div style={{ fontWeight: 600, fontSize: "1.1em" }}>
                    {msg.subject || <span style={{ opacity: 0.7 }}>(Kein Betreff)</span>}
                  </div>
                  <div style={{ opacity: 0.8, marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 }}>
                    An: <b>{msg.recipientDisplayName || msg.recipientUsername || msg.recipientId}</b> &nbsp;•&nbsp; {new Date(msg.sentAt).toLocaleString()}
                    {/* WhatsApp-like status icons */}
                    <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 2 }}>
                      {/* Single gray checkmark: sent */}
                      {!msg.delivered && (
                        <svg width="22" height="22" viewBox="0 0 22 22" style={{ verticalAlign: 'middle' }}><path d="M6 12l4 4 6-8" stroke="#888" strokeWidth="2.2" fill="none" strokeLinecap="round"/></svg>
                      )}
                      {/* Double gray checkmark: delivered */}
                      {msg.delivered && !msg.read && (
                        <>
                          <svg width="22" height="22" viewBox="0 0 22 22" style={{ verticalAlign: 'middle' }}><path d="M6 12l4 4 6-8" stroke="#888" strokeWidth="2.2" fill="none" strokeLinecap="round"/></svg>
                          <svg width="22" height="22" viewBox="0 0 22 22" style={{ marginLeft: -12, verticalAlign: 'middle' }}><path d="M2 12l4 4 6-8" stroke="#888" strokeWidth="2.2" fill="none" strokeLinecap="round"/></svg>
                        </>
                      )}
                      {/* Double blue checkmark: read */}
                      {msg.delivered && msg.read && (
                        <>
                          <svg width="22" height="22" viewBox="0 0 22 22" style={{ verticalAlign: 'middle' }}><path d="M6 12l4 4 6-8" stroke="#32CD89" strokeWidth="2.2" fill="none" strokeLinecap="round"/></svg>
                          <svg width="22" height="22" viewBox="0 0 22 22" style={{ marginLeft: -12, verticalAlign: 'middle' }}><path d="M2 12l4 4 6-8" stroke="#32CD89" strokeWidth="2.2" fill="none" strokeLinecap="round"/></svg>
                        </>
                      )}
                    </span>
                  </div>
                  <div style={{ marginBottom: 8 }}>{msg.body}</div>
                  <Link to={`/messages/${msg.id}`} style={{ background: "#32CD89", color: "#fff", padding: "8px 16px", borderRadius: 8, fontWeight: 500, textDecoration: "none" }}>Details</Link>
                </li>
              ))}
            </ul>
          )
        )}
      </div>
    </div>
  );
}
